"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_perfect_scrollbar_1 = __importDefault(require("react-perfect-scrollbar"));
var store_1 = require("../../store");
var Search = antd_1.Input.Search;
var MasterArea = function (props) {
    var type = props.type, dataSource = props.dataSource, renderItem = props.renderItem, onSearch = props.onSearch, onYReachEnd = props.onYReachEnd;
    var t = react_i18next_1.useTranslation().t;
    var setHasMasterArea = store_1.useActions(function (actions) { return actions.ui.setHasMasterArea; });
    react_1.useEffect(function () {
        setHasMasterArea(true);
        return function () { return setHasMasterArea(false); };
    });
    var handleSearch = lodash_1.debounce(function (value) { return onSearch && onSearch(value); }, 600);
    return (react_1.default.createElement("div", null,
        onSearch && (react_1.default.createElement("div", { className: "ant-app-masterarea-search" },
            react_1.default.createElement(Search, { placeholder: t('ui.commons.input.search'), onChange: function (event) { return handleSearch(event.target.value); } }))),
        react_1.default.createElement(react_perfect_scrollbar_1.default, { onYReachEnd: function (e) { return onYReachEnd && onYReachEnd(e.scrollTop); } },
            react_1.default.createElement("div", { className: "ant-app-masterarea-content" }, type === 'list' && react_1.default.createElement(antd_1.List, { itemLayout: "horizontal", dataSource: dataSource, renderItem: renderItem })))));
};
exports.default = MasterArea;
